export const assets = {
  ada: {
    name: 'Cardano',
    description: 'asset.ada.description'
  },
  bch: {
    name: 'Bitcoin Cash',
    description: 'asset.bch.description'
  },
  btc: {
    name: 'Bitcoin',
    description: 'asset.btc.description'
  },
  dot: {
    name: 'Polkadot',
    description: 'asset.dot.description'
  },
  eth: {
    name: 'Ether',
    description: 'asset.eth.description'
  },
  link: {
    name: 'Chainlink',
    description: 'asset.link.description'
  },
  ltc: {
    name: 'Litecoin',
    description: 'asset.ltc.description'
  },
  sol: {
    name: 'Solana',
    description: 'asset.sol.description'
  },
  uni: {
    name: 'Uniswap',
    description: 'asset.uni.description'
  },
  xrp: {
    name: 'XRP',
    description: 'asset.xrp.description'
  }
};
